import ServiceExec from '@/common/utils/ServiceExec';
import { notice } from '@/common/service/apiList';

export default {
  getNoticeList: async function({ commit, getters }) {
    const condition = getters['getCondition'];
    const { data, status } = await ServiceExec.get(notice.getList, condition);
    if (ServiceExec.status.OK !== status) return false;
    const { list, pageInfo } = data;
    if (condition.page > pageInfo.totalPage) return false;
    condition.page = condition.page + 1;
    commit('setCondition', condition);
    commit('setNoticeList', list ?? []);
  },
  async getDetail({ commit, getters, state }, noticeNo) {
    const { data, status } = await ServiceExec.get(notice.getDetail + noticeNo);
    if (ServiceExec.status.OK !== status) return;
    commit('setDetail', data ?? '');
  }
};
